<mat-form-field style="width: 100%">
    <mat-label>Tierart</mat-label>
    <mat-select
        #select
        [formControl]="tierartCtrl"
        (selectionChange)="tierartChanged($event)"
        [multiple]="multiple"
        [compareWith]="tierartComparator"
        (focus)="openPanel()"
    >
        <mat-option *ngIf="zeigeKeine">Keine</mat-option>
        <mat-option *ngFor="let t of tierarten" [value]="t">{{ t.tierart }}</mat-option>
    </mat-select>
</mat-form-field>
